/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TenantIntegrationTemplate from './tenant-integration-template';
import TenantIntegrationTemplateDetail from './tenant-integration-template-detail';
import TenantIntegrationTemplateUpdate from './tenant-integration-template-update';
import TenantIntegrationTemplateDeleteDialog from './tenant-integration-template-delete-dialog';

const TenantIntegrationTemplateRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TenantIntegrationTemplate />} />
    <Route path="new" element={<TenantIntegrationTemplateUpdate />} />
    <Route path=":id">
      <Route index element={<TenantIntegrationTemplateDetail />} />
      <Route path="edit" element={<TenantIntegrationTemplateUpdate />} />
      <Route path="delete" element={<TenantIntegrationTemplateDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TenantIntegrationTemplateRoutes;
